// extracted by mini-css-extract-plugin
export default {"BreadCrumbDropdown":"_BreadCrumbDropdown--xi1S7","BreadCrumbDropdownItem":"_BreadCrumbDropdownItem--MiFtd"};